import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "キャンセル" },
  { value: 2, text: "却下" },
]);
